import { Link } from "react-router-dom";
import { reviews } from "../../../mocks/reviewsData";
import ScrollReveal from "../../../components/feature/ScrollReveal";

export default function ReviewsList() {
  return (
    <section className="py-16 md:py-24 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {reviews.map((item, idx) => (
              <ScrollReveal key={item.name} direction="up" delay={idx * 80}>
                <div className="bg-white border border-airdoa-gray-light/50 rounded-lg overflow-hidden h-full flex flex-col">
                  <div className="aspect-[16/9] overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.scene}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-5 md:p-6 flex-1 flex flex-col">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: item.rating }).map((_, i) => (
                        <span key={i} className="w-4 h-4 flex items-center justify-center text-airdoa-gold">
                          <i className="ri-star-fill text-sm" />
                        </span>
                      ))}
                    </div>
                    <p className="text-sm text-airdoa-navy leading-relaxed flex-1">
                      {item.comment}
                    </p>
                    <div className="mt-4 pt-4 border-t border-airdoa-gray-light/50 flex items-center justify-between">
                      <div>
                        <p className="text-sm font-medium text-airdoa-navy">{item.name}</p>
                        <p className="text-xs text-airdoa-gray">{item.age} / {item.date}</p>
                      </div>
                      <span className="px-2 py-1 text-[10px] font-medium text-airdoa-gold bg-airdoa-cream rounded">
                        {item.scene}
                      </span>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal direction="up" delay={200}>
            <div className="mt-12 text-center">
              <Link to="/yokohama" className="btn-primary">
                横浜ヘリクルージングを見る
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}